import * as l from "../../lib/littlejs.esm";
import { tilesize, tilesheets } from '../const/tiles.ts';
import Globals from '../globals';
class Checkpoint extends l.EngineObject {
    constructor(pos) {
        const checkpointTile = l.tile(3, tilesize, tilesheets.ASSETS);
        super(pos, l.vec2(1, 1), checkpointTile, 0, l.hsl(0, 0, 1), 1);
        this.collideTiles = false;
        this.collideSolidObjects = false;
        this.mass = 0;
        this.passed = false;
        this.messageTimer = 0;
    }
    update() {
        super.update();
        if (!this.passed) {
            if (Globals.rex && this.pos.distance(Globals.rex.pos) < 1) {
                Globals.lastCheckpoint = this.pos.copy();
                this.passed = true;
                this.messageTimer = 3; // 3 seconds
            }
            if (Globals.chip && this.pos.distance(Globals.chip.pos) < 1) {
                Globals.lastCheckpoint = this.pos.copy();
                this.passed = true;
                this.messageTimer = 3; // 3 seconds
            }
        }
        if (this.messageTimer > 0) {
            this.messageTimer -= l.timeDelta;
        }
    }
    render() {
        super.render();
        if (this.messageTimer > 0) {
            l.drawText('Checkpoint!', this.pos.add(l.vec2(0, 1)), 0.5, l.hsl(0, 0, 1), 0.1);
        }
    }
}
export default Checkpoint;
